export enum MandatePublicStatusEnum {
  OPENED = "opened",
  PRIVATE = "private",
  CLOSED = "closed"
}

export enum MandateBoStatusEnum {
  DRAFT = "draft",
  PENDING = "pending",
  PENDING_DIC = "pending_dic",
  VALIDATED = "validated",
  REFUSED = "refused"
}

export enum MandateDocumentCategoryEnum {
  DIC = "dic",
  OTHER = "other",
  MANAGEMENT_REPORT = "management_report"
}

export enum TradingOrderTypeEnum {
  MARKET_ORDER = "market_order",
  LIMIT_ORDER = "limit_order",
  TRAILING_STOP_ORDER = "trailing_stop_order"
}